import React from 'react';
import { List } from 'semantic-ui-react'
import {flowRight as compose} from 'lodash';
import {graphql} from 'react-apollo';
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';

var moment = require('moment');

const DetalleNivel1 = ({styles, elemento, handleClickidLista, a251025}) => {
  let fechaHoy = new Date()
  fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  fechaHoy=moment(fechaHoy)
  let numDias=0
  if(elemento.vigenteHasta){
    let fecFin=moment(elemento.vigenteHasta).format('YYYY-MM-DD')
    numDias= fechaHoy.diff(fecFin, 'days')-1 
  }
  let colorCelda='white'
  if(numDias>0){
      colorCelda = 'red'
  } 
  if(a251025!==-1){ 
    return (
      <tr className=''>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numProducto?elemento.numProducto:0}</td>       
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.tipoProducto}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.tipoOrden}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.marca}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrProducto}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.codigo?elemento.codigo:''}</td>        
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrLubricante?elemento.descrLubricante:'NINGUNO'}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrUnidad?elemento.descrUnidad:''}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.costo?elemento.costo:0}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.precio?new Intl.NumberFormat('de-DE').format(elemento.precio):0}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.precioDolar?new Intl.NumberFormat('de-DE').format(elemento.precioDolar):0}</td> 
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.vigenteHasta?elemento.vigenteHasta.substr(0, 10):''}</td>        
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.porcIVA}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.porcImpto?elemento.porcImpto:0}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.estado}</td>
        <td className='' style={{color: 'black', background: '#FFFFFF'}}>
          <a style={{color: 'black'}}
            href={'images/fichas/' + elemento.ficha}
              target="_blank">
            {elemento.ficha}
          </a>
        </td> 
        <td className='' style={{color: 'black', background: '#FFFFFF'}}>
          <a style={{color: 'black'}}
            href={'images/fichas/' + elemento.ficha2}
              target="_blank">
            {elemento.ficha2} 
          </a>
        </td> 
      </tr>  
    )
  }else{
    return (
      <tr className=''>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numProducto?elemento.numProducto:0}</td>       
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.tipoProducto}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.tipoOrden}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.marca}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrProducto}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.codigo?elemento.codigo:''}</td>        
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrLubricante?elemento.descrLubricante:'NINGUNO'}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrUnidad?elemento.descrUnidad:''}</td>
        {/* <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.costo?elemento.costo:0}</td> */}
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.precio}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.precioDolar?elemento.precioDolar:0}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.vigenteHasta?elemento.vigenteHasta.substr(0, 10):''}</td>        
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.porcIVA}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.porcImpto?elemento.porcImpto:0}</td>
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.estado}</td>
        <td className='' style={{color: 'black', background: '#FFFFFF'}}>
          <a style={{color: 'black'}}
            href={'images/fichas/' + elemento.ficha}
              target="_blank">
            {elemento.ficha}
          </a>
        </td> 
        <td className='' style={{color: 'black', background: '#FFFFFF'}}>
          <a style={{color: 'black'}}
            href={'images/fichas/' + elemento.ficha2}
              target="_blank">
            {elemento.ficha2} 
          </a>
        </td> 
      </tr>  
    )
  }
};

const Lista = ({list, handleClickidLista, a251025}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} a251025={a251025}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
}; 

// const ConfProducto2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
class ConfProducto2 extends React.Component {  
  state={argsBuscProd: {}, ingresa: 'S'}

  handleOrdenaLista(itemOrdena){
    console.log(itemOrdena)
    let argsBuscPro = ""
    argsBuscPro = {tipoqry: `[{$sort: {${itemOrdena}: 1}}]`}
    console.log(argsBuscPro)

    this.props.allProductoRtes.refetch(argsBuscPro)  
    this.setState({argsBuscProd: this.props.argsBuscPro})    
  }

  componentDidUpdate(prevProps){
    if(this.props.argsBuscPro!==this.state.argsBuscProd || this.state.ingresa==='S'){
      let argsBuscPro = ""
      let argsBuscar = "tipoProducto: {$in: ['Producto', 'Servicio', 'Programa']}"
      if(this.props.argsBuscPro.tipoProducto){
        argsBuscar += `, 'tipoProducto': /${this.props.argsBuscPro.tipoProducto}/i`
      }
      if(this.props.argsBuscPro.marca){
        argsBuscar += `, 'marca': /${this.props.argsBuscPro.marca}/i`
      }
      if(this.props.argsBuscPro.descrProducto){
        argsBuscar += `, 'descrProducto': /${this.props.argsBuscPro.descrProducto}/i`
      }
      if(this.props.argsBuscPro.estado){
        argsBuscar += `, 'estado': '${this.props.argsBuscPro.estado}'`
      }else{
        if(this.state.ingresa==='S'){argsBuscar += `, 'estado': 'Activo'`}
      }
      argsBuscPro = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {descrProducto: 1}}]`}
      this.setState({ingresa: 'N'})
      this.props.allProductoRtes.refetch(argsBuscPro)  
      this.setState({argsBuscProd: this.props.argsBuscPro})    
    }
  }

// const a251010 = autorizacUA.findIndex( autorizac => autorizac === "251010" )

  render(){
    let list = []
    const a251010 = this.props.autorizacUA.findIndex( autorizac => autorizac === "251010" );
    const a251025 = this.props.autorizacUA.findIndex( autorizac => autorizac === "251025" );
    if(this.props.allProductoRtes.allProductoRtes){list = this.props.allProductoRtes.allProductoRtes}
    if(this.state.ingresa==='S'){
      list = list.filter(elemento => elemento.estado==='Activo')
    }
    return (
      <div>
        <List selection>
          <TitDer list={list} textBoton1="Productos" btnNuevo={a251010!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />
          <div>
            {a251025!==-1 &&
              <div style={{height: '55em', overflow: 'auto'}}>
                <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('numProducto')}># producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('tipoProducto')}>Tipo de producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('tipoOrden')}>Tipo de orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('marca')}>Marca</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('descrProducto')}>Producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('codigo')}>Código</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('descrLubricante')}>Lubricante asociado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('descrUnidad')}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('costo')}>Costo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('precio')}>Precio und en $</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('precioDolar')}>Precio und en $US</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('vigenteHasta')}>Fecha de vigencia de precio</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('porcIVA')}>% IVA</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('porcImpto')}>% ITBMS</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('estado')}>Estado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('ficha')}>Ficha técnica</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('ficha2')}>Ficha de seguridad</th>
                    </tr>              
                  </thead>
                  <Lista list={list} handleClickidLista={this.props.handleClickidLista} a251025={a251025}/>
                </table>
              </div>
            }
            {a251025===-1 &&
              <div style={{height: '55em', overflow: 'auto'}}>
                <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('numProducto')}># producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('tipoProducto')}>Tipo de producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('tipoOrden')}>Tipo de orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('marca')}>Marca</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('descrProducto')}>Producto</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('codigo')}>Código</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('descrLubricante')}>Lubricante asociado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('descrUnidad')}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('precio')}>Precio und en $</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('precioDolar')}>Precio und en $US</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('vigenteHasta')}>Fecha de vigencia de precio</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('porcIVA')}>% IVA</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('porcImpto')}>% ITBMS</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('estado')}>Estado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('ficha')}>Ficha técnica</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}} onClick={(ev)=>this.handleOrdenaLista('ficha2')}>Ficha de seguridad</th>
                    </tr>              

                  </thead>
                  <Lista list={list} handleClickidLista={this.props.handleClickidLista} a251025={a251025}/>
                </table>
              </div>
            }
            <p></p>
          </div>
        </List>
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allProductoRtes, {name:'allProductoRtes',
    options: (props) => {return {variables: {tipoqry: `[{$sort: {numProducto: 1}}]`}}}}),
    
) (ConfProducto2)